module.exports = __webpack_public_path__ + "static/media/scheme9.12622c6b.png";